<div class="container0">
  <div class="search-container">
    <div class="search-header">
      <mat-form-field class="search-field" appearance="outline" *ngIf="showSearchField">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput 
               placeholder="Rechercher des utilisateurs ou des publications" 
               [(ngModel)]="searchQuery" 
               (input)="onSearch()" />
        <button mat-icon-button matSuffix *ngIf="searchQuery" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>Filtrer par</mat-label>
        <mat-select [(value)]="selectedFilter" (selectionChange)="onFilterChange()">
          <mat-option value="all">
            <mat-icon>all_inclusive</mat-icon>
            <span>Tous</span>
          </mat-option>
          <mat-option value="users">
            <mat-icon>people</mat-icon>
            <span>Utilisateurs</span>
          </mat-option>
          <mat-option value="posts">
            <mat-icon>article</mat-icon>
            <span>Publications</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- État de chargement -->
  <div class="loading-state" *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- Message si aucun résultat -->
  <div class="no-results" *ngIf="!isLoading && suggestions.length === 0 && suggestions2.length === 0 && searchQuery">
    <mat-icon>search_off</mat-icon>
    <p>Aucun résultat trouvé pour "{{searchQuery}}"</p>
  </div>

  <!-- Liste des suggestions -->
  <mat-list *ngIf="suggestions.length > 0 || suggestions2.length > 0" class="suggestions-list">
    <div class="results-header">
      <h3>Résultats ({{suggestions.length + suggestions2.length}})</h3>
      <mat-chip-list>
        <mat-chip [selected]="selectedFilter === 'all'" (click)="selectedFilter = 'all'; onFilterChange()">Tous</mat-chip>
        <mat-chip [selected]="selectedFilter === 'users'" (click)="selectedFilter = 'users'; onFilterChange()">
          Utilisateurs ({{suggestionsUser.length}})
        </mat-chip>
        <mat-chip [selected]="selectedFilter === 'posts'" (click)="selectedFilter = 'posts'; onFilterChange()">
          Publications ({{suggestionsPost.length}})
        </mat-chip>
      </mat-chip-list>
    </div>

    <div class="container4">
      <!-- Utilisateurs -->
      <div *ngFor="let suggestion of suggestionsUser">
        <mat-card class="suggestion-card user-card" *ngIf="suggestion.type === 'user'">
          <div class="user-card-content">
            <div class="user-info-container">
              <div class="user-avatar">
                <img [src]="suggestion.profilePhotoUrl ? suggestion.profilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" 
                     [alt]="suggestion.publicName"
                     class="profile-picture">
              </div>
              <div class="user-info">
                <h3 class="user-name">{{ suggestion.publicName }}</h3>
                <p class="user-description">
                  <span class="description">{{ suggestion.description }}</span>
                  <span class="location" *ngIf="suggestion.ville">
                    <mat-icon class="location-icon">location_on</mat-icon>
                    {{ suggestion.ville }}
                  </span>
                </p>
              </div>
            </div>
            <div class="user-actions">
              <button mat-flat-button class="mat-flat-button action-button" (click)="followUser(suggestion)">
                <mat-icon>{{ suggestion.isFollowed ? 'check' : 'add' }}</mat-icon>
                <span class="button-text">{{ suggestion.isFollowed ? 'Suivi' : 'Suivre' }}</span>
              </button>
              <button mat-flat-button class="mat-flat-button action-button" [routerLink]="['/postfeed/userprofile', suggestion.uid]">
                <mat-icon>person</mat-icon>
                <span class="button-text">Voir le profil</span>
              </button>
            </div>
          </div>
        </mat-card>
      </div>

      <!-- Publications -->
      <div class="posts-container">
        <app-post *ngFor="let post of suggestionsPost" [postData]="post"></app-post>
      </div>
    </div>
  </mat-list>
</div>